import { Component, Input, OnInit } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import { PaxOverviewType } from 'src/app/crew-management-user/enums/pax-overview-type.enum';
import {
  TripVersionReason,
  TripVersionReasonLabels,
} from 'src/app/crew-management-user/enums/trip-version-reason.enum';
import { ITripLogFieldChange } from 'src/app/crew-management-user/models/trip.model';
import { PersonOnBoardType } from '../../../../../crew-management-user/models/current-personnel/personnel-with-missing-confirmation.model';

@Component({
  selector: 'app-crew-management-user-template',
  templateUrl: './crew-management-user-template.component.html',
  styleUrls: ['./crew-management-user-template.component.scss'],
  standalone: false,
})
export class CrewManagementUserTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;

  paxOverviewType = PaxOverviewType;
  personOnBoardType = PersonOnBoardType;
  tripVersionReasonLabels: any = TripVersionReasonLabels;
  dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;

  fieldChangesWithTranslations: Array<ITripLogFieldChange & { translationKey: string }> = [];
  removeTranslationKeys = ['Attachments added', 'Attachments removed'];

  ngOnInit(): void {
    delete this.tripVersionReasonLabels[TripVersionReason.Updated];
    this.fieldChangesWithTranslations = (this.element?.fieldsChanged || []).map(
      (fieldChange: ITripLogFieldChange) => {
        let translationKey = 'changedTo';
        if (this.removeTranslationKeys.includes(fieldChange.fieldName)) {
          translationKey = '';
        }
        if (this.element.tripVersionReason === TripVersionReason.Created) {
          translationKey = 'setTo';
        }
        return {
          ...fieldChange,
          translationKey,
        };
      }
    );
  }
}
